import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-common-pop-up',
  templateUrl: './common-pop-up.component.html',
  styleUrls: ['./common-pop-up.component.css']
})
export class CommonPopUpComponent implements OnInit {

  iconCloseButton = faTimesCircle;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    console.log("data", this.data);


  }

}
